import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		curview: '',
		orderRmb:0,
		searchRoomId:'',
		isLogin:false,
		channelID:'',
		sourceType:'',
		tips:'',
		forceLogin:false,
		isYouxi: false,
	},
	mutations: {
		getCurview(state, data) {
			state.curview = data
		},
		getOrderRmb(state, data){
			state.orderRmb = data
		},
		getSearchRoomId(state, data){
			state.searchRoomId = data
		},
		getIsLogin(state, data) {
			state.isLogin = data
		},
		getChannelID(state, data) {
			state.channelID = data
		},
		getSourceType(state, data) {
			state.sourceType = data
		},
		getTips(state, data) {
			state.tips = data
		},
		getForceLogin(state, data) {
			state.forceLogin = data
		},
		isYouxi(state, data) {
			state.isYouxi = data
		},
		
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js